import React from 'react';
import { FILTER_PRESETS } from 'constants/filters';
import FilterPresetButton from './FilterPresetButton';

export default function VibrantPopFilter() {
  return (
    <FilterPresetButton
      presetKey={FILTER_PRESETS.VIBRANT_POP}
      label="Vibrant Pop"
      image="vibrantpop"
      thumbnailClassName="bg-gradient-to-br from-fuchsia-200 via-amber-200 to-cyan-200"
    />
  );
}
